import { useAuth } from '@backoffice-frontend/authentication'
import { ContentInfo } from '@backoffice-frontend/patterns'
import { useTranslation } from 'react-i18next'

export const MFASuccessfulEnabledView = () => {
  const { hasMFA } = useAuth()
  const { t } = useTranslation()

  return (
    <>
      {hasMFA && (
        <ContentInfo
          variant="success"
          title={t('authenticatedAppView_mfaEnabled_title')}
          infoText={t('authenticatedAppView_mfaEnabled_caption')}
        />
      )}
    </>
  )
}
